// Shared by the header bell and the Activity page

export const formatTimeAgo = (dateStr) => {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};

export const formatNotifMessage = (n) => {
  const actor = n.User ? (n.User.loginId ? n.User.loginId.charAt(0).toUpperCase() + n.User.loginId.slice(1) : n.User.firstName) : 'Someone';
  const et = n.details?.entityType || 'invoice';
  const action = n.action;
  if (et === 'invoice') {
    const vendor = n.details?.vendorName || n.details?.vendor || '';
    if (action === 'create') return `${actor} added expense${vendor ? ` — ${vendor}` : ''}`;
    if (action === 'update') return `${actor} updated expense${vendor ? ` — ${vendor}` : ''}`;
    if (action === 'delete') return `${actor} deleted expense${vendor ? ` — ${vendor}` : ''}`;
    if (action === 'download') return `${actor} downloaded invoice`;
  }
  if (et === 'timesheet') {
    const date = n.details?.date || '';
    const fmtDate = d => {
      if (!d) return '';
      const today = new Date().toISOString().slice(0, 10);
      const yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
      if (d === today) return 'today';
      if (d === yesterday) return 'yesterday';
      return d;
    };
    if (action === 'create') return `${actor} checked-in ${fmtDate(date)}`;
    if (action === 'update') {
      const changes = n.details?.changes || {};
      if (changes.checkOut) return `${actor} checked-out ${fmtDate(date)}`;
      if (changes.checkIn) return `${actor} checked-in ${fmtDate(date)}`;
      return `${actor} updated timesheet ${fmtDate(date)}`;
    }
    if (action === 'delete') return `${actor} deleted timesheet ${fmtDate(date)}`;
  }
  if (et === 'todo') {
    const title = n.details?.title ? `"${n.details.title}"` : 'a todo';
    const statusLabel = { todo: 'Todo', in_progress: 'In Progress', blocked: 'Blocked', in_review: 'In Review', completed: 'Done' };
    if (action === 'create') return `${actor} created todo ${title}`;
    if (action === 'delete') return `${actor} deleted todo ${title}`;
    if (action === 'update') {
      const prev = n.details?.prevStatus;
      const next = n.details?.status;
      if (prev && next && prev !== next)
        return `${actor} moved ${title} → ${statusLabel[next] || next}`;
      return `${actor} updated todo ${title}`;
    }
  }
  if (et === 'vacation') {
    if (action === 'create') return `${actor} requested leave (${n.details?.startDate} – ${n.details?.endDate})`;
  }
  if (et === 'voice_note') {
    const leadName = n.details?.leadName ? ` for ${n.details.leadName}` : '';
    return `${actor} added a voice recording${leadName}`;
  }
  if (et === 'follow_up') {
    const leadName = n.details?.leadName || 'a lead';
    return `Follow up with ${leadName} today`;
  }
  if (et === 'installment') {
    const title = n.details?.title || 'Installment reminder';
    const desc = n.details?.description;
    return desc ? `${title} — ${desc}` : title;
  }
  return `${actor} ${action}`;
};

export const getNotifLink = (n) => {
  const et = n.details?.entityType;
  if (et === 'timesheet') return '/work/timesheets';
  if (et === 'todo')      return '/work/todos';
  if (et === 'vacation')  return '/work/leave';
  if (et === 'voice_note') return '/leads';
  if (et === 'follow_up') return '/leads';
  if (et === 'installment') return '/work/reminders';
  return '/dashboard';
};

// Filter options for the Activity page; reminders are the only types an
// employee receives, the rest are super-admin activity.
export const NOTIF_TYPES = [
  { value: 'todo',        label: 'Todos',       adminOnly: true },
  { value: 'timesheet',   label: 'Timesheets',  adminOnly: true },
  { value: 'invoice',     label: 'Expenses',    adminOnly: true },
  { value: 'vacation',    label: 'Leave',       adminOnly: true },
  { value: 'voice_note',  label: 'Voice notes', adminOnly: true },
  { value: 'follow_up',   label: 'Follow-ups' },
  { value: 'installment', label: 'Installments' },
];

export const getNotifType = (n) => n.details?.entityType || 'invoice';
